import Vue from 'vue'
import App from './App'
// 引入Axios
//import axios from 'axios'
import axios from 'axios'
import qs from 'qs'
// 引入js-cookie
import cookies from 'js-cookie'
// Element UI 按需引入（2026-10-03）：组件清单与程序化 API 统一在 utils/element.js
// —— 原来是 `import ElementUI from 'element-ui'` + `Vue.use(ElementUI)` 全量注册，
//    element-ui 入口是 CJS，webpack 摇不掉没用到的组件，全部塞进首屏 chunk-vendors。
import './utils/element'
import Message from 'element-ui/lib/message'
import 'element-ui/lib/theme-chalk/index.css'
// import './styles/element-variables.scss'
import './utils/filter_utils.js'
import router from './router'
import Navigation from 'vue-navigation'
import store from './store'
import eventBus from './store/eventBus'
Vue.use(Navigation, {router})
Vue.prototype.$axios = axios
Vue.prototype.cookies = cookies
// 七牛云的静态资源 —— 走【入口层同源反代】/oss/（见 deploy/public/entry/nginx.conf 的 ⑤）
//  ⚠️ 不要改回 http://static.huanzhidadi.com/：全站上 HTTPS 后，https 页面里加载 http
//     图片会被浏览器当「混合内容」处理 —— 该七牛加速域名没绑证书（443 上是 CDN 默认
//     占位证书），Chrome 自动升级到 https 失败后**直接拦截且不回退**，Firefox 一律拦，
//     表现为游戏内图片成片空白。
//  用根相对路径 /oss/：www / 根域 / 局域网（http://192.168.2.225）三种入口都成立，
//  且与页面同源，顺带没有跨域问题。
Vue.prototype.ossPath = '/oss/';
// 全局业务常量（背包容量/柜子数量/地面格位），与后端 Constants 对齐
import {POCKET_VOLUME, CABINET_MAX_COUNT, GROUND_ITEM_LIMIT} from './utils/constants'
Vue.prototype.POCKET_VOLUME = POCKET_VOLUME
Vue.prototype.CABINET_MAX_COUNT = CABINET_MAX_COUNT
Vue.prototype.GROUND_ITEM_LIMIT = GROUND_ITEM_LIMIT
Vue.config.productionTip = false
window.bus = new Vue();
const vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App},
  data: {
    eventHub: eventBus,
    // 控制显示登录还是注销
    loginStatus: true
  },
  created: function () {
    // axios baseURL
    //this.$axios.defaults.baseURL = 'http://localhost:8080'
    //this.$axios.defaults.timeout = 10000

    const accessToken = this.cookies.get('accessToken')
    if (accessToken && accessToken !== '') {
      this.$root.loginStatus = false
    } else {
      this.$root.loginStatus = true
    }
    /* if (cookies.get('accessToken') && cookies.get('accessToken') !== '') {
      axios.defaults.headers.common['Authorization'] = cookies.get('accessToken')
    } */

    // 请求拦截器设置headers
    this.$axios.interceptors.request.use(config => {
      // Do something before request is sent
      const accessToken = this.cookies.get('accessToken')
       //console.log(accessToken);
      if (accessToken && accessToken !== '') {
        // console.log('Authorization: ' + accessToken);
        // config.headers.common['Authorization'] = accessToken
        config.headers['Authorization'] = accessToken
      }

      if(config.method === 'post' && config.data && typeof config.data === 'object') {
        const contentType = config.headers['Content-Type'];
        const isJson = contentType && contentType.indexOf('application/json') !== -1;
        if (!isJson) {
          config.data = qs.stringify(config.data);
        }
      }

      return config
    }, error => {
      // Do something with request error
      return Promise.reject(error)
    })

    // 响应拦截器获取headers，设置(刷新)Token
    this.$axios.interceptors.response.use(response => {
      // 业务认证失败检测（HTTP 200 + 业务status非200 + message含认证失败）
      if (response.data && response.data.status && response.data.status !== 200 && response.data.message && response.data.message.includes('认证失败')) {
        this.cookies.remove('accessToken');
        const ap = document.getElementById('aplayer'); if (ap) ap.remove();
        router.replace({path: '/'});
        return response
      }
      // Do something with response data
      const accessToken = response.headers['authorization']
      if (accessToken && accessToken !== '') {
        this.cookies.set('accessToken', accessToken, { expires: 1, path: '/' })
      }
      return response
    }, error => {
      if (error.response && error.response.status === 401) {
        this.cookies.remove('accessToken');
        const ap = document.getElementById('aplayer'); if (ap) ap.remove();
        router.replace({path: '/'});
      }
      Message.error('网络异常，请稍后重试');
      return Promise.reject(error)
    })
  },
  render: h => h(App)
})
global.vm = vm;
// ===== 屏蔽浏览器前进后退（2026-10-17 修复）=====
// 原来这两句写在 router.beforeEach 里，等于「每次路由跳转都执行一遍」：
//   ① history.pushState 再压一条历史（后退栈无限增长）
//   ② window.addEventListener('popstate', ...) 再挂一个监听，而且【永远不解绑】
// 后果：SPA 内导航 N 次后就有 N 个 popstate 监听器；用户一旦触发返回
// （手机全面屏的侧滑返回最容易触发），一次 popstate 会执行 N 次 history.go(1)，
// 而 go(1) 本身又会产生新的 popstate ⇒ 事件指数级放大，主线程被彻底占满，
// 浏览器随即弹「网页暂无响应」。整页刷新会把监听器清零，所以「刷新一下就好了」。
// 修法：监听器全局只注册一次 + _popLock 防重入（go(1) 不再级联）。
let _popLock = false;
window.addEventListener('popstate', function () {
  if (_popLock) return;
  _popLock = true;
  history.go(1);
  setTimeout(function () { _popLock = false; }, 200);
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
  //防止页面后退 屏蔽浏览器前进后退操作（监听器已提到外面，这里只补历史条目）
  history.pushState(null, null, location.href);
})
// ========== 移动端：键盘弹出时动态调整视口高度 ==========
function setViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
}
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', setViewportHeight);
}
setViewportHeight();

// 输入框自动选中，标签中加上v-myfocus
Vue.directive('myfocus', {
  inserted: function(el, binding) {
  //console.log(el)
  el.focus()
  }
})
